import React, { useState } from 'react';

import { MarketCard } from '@eika/card';

import FavoriteAccountImg from '../../../../components/FavoriteAccount/FavoriteAccountImg';
import FavoriteAccountModal from '../../../../components/FavoriteAccountModal/FavoriteAccountModal';
import { accountListSelector, useAccounts } from '../../../../fetchHooks/useAccount';
import useFavoriteAccount from '../../../../fetchHooks/useFavoriteAccount';
import useTranslation from '../../../../hooks/useTranslation';

export const FavoriteAccountCard = () => {
    const translated = useTranslation();

    const { data: accounts } = useAccounts({ select: accountListSelector });

    const { data: favoriteAccount, isLoading: loadingFavoriteAccount } = useFavoriteAccount();
    const [showFavoriteAccountModal, setShowFavoriteAccountModal] = useState<boolean>(false);

    const hasAccount = !!accounts && accounts.length > 0;
    const hasFavoriteAccount = !!favoriteAccount;
    return (
        <>
            {!hasFavoriteAccount && hasAccount && !loadingFavoriteAccount && (
                <MarketCard
                    className="select-favorite-account-card"
                    header={<FavoriteAccountImg mini />}
                    title={translated.favoriteAccount.favoriteAccountCardTitle}
                    secondaryButton={
                        <MarketCard.SecondaryButton
                            onClick={() => setShowFavoriteAccountModal(!showFavoriteAccountModal)}
                        >
                            {translated.favoriteAccount.favoriteAccountCardButtonText}
                        </MarketCard.SecondaryButton>
                    }
                >
                    {translated.favoriteAccount.favoriteAccountCardDescription}
                </MarketCard>
            )}
            <FavoriteAccountModal
                showModal={showFavoriteAccountModal}
                setShow={() => setShowFavoriteAccountModal(false)}
            />
        </>
    );
};
